import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("sessionExpired")) {
      setErrorMessage("Session expired, please log in again.");
      sessionStorage.removeItem("sessionExpired"); // Clear the flag after showing the message
    }
  }, []);
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setErrorMessage("");

      try {
        const response = await axios.post("/api/auth/login", {
          email: values.username.toLowerCase().trim(),
          password: values.password,
        });

        const {
          accessToken,
          refreshToken,
          passwordChangeRequired,
          needsCompanySelection,
        } = response.data;

        localStorage.setItem("token", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        window.dispatchEvent(new Event("tokenUpdated"));

        if (passwordChangeRequired) {
          navigate("/change-password");
        } else if (needsCompanySelection) {
          navigate("/select-company");
        } else {
          navigate("/report");
        }

        formik.resetForm();
      } catch (error) {
        setErrorMessage(error.response?.data?.message || "Login failed");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <form
        onSubmit={formik.handleSubmit}
        className="w-full max-w-md bg-white p-6 rounded shadow-md space-y-4"
      >
        <h2 className="text-2xl mb-4 font-bold">Login</h2>
        {errorMessage && <div className="text-red-500">{errorMessage}</div>}
        <div>
          <label className="block text-gray-700">Username</label>
          <input
            type="text"
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full px-3 py-2 border rounded"
          />
          {formik.touched.username && formik.errors.username ? (
            <div className="text-red-500">{formik.errors.username}</div>
          ) : null}
        </div>
        <div>
          <label className="block text-gray-700">Password</label>
          <input
            type="password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full px-3 py-2 border rounded"
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="text-red-500">{formik.errors.password}</div>
          ) : null}
        </div>
        <button
          type="submit"
          className="w-full px-3 py-2 bg-blue-500 text-white rounded"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
        <div className="flex justify-between mt-4">
          <button type="button" className="text-blue-500 underline">
            Forgot password
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;
